import { graphql } from 'gatsby';
import { ContentEntityTaxonomyLayout, createGatsbyPageComponent } from '@shapeable/ui';

export default createGatsbyPageComponent('Reflection', { layout: ContentEntityTaxonomyLayout });

export const QUERY = graphql`
query ReflectionQuery($id: ID!) {
  platform { reflection(id: $id) {
    id
    slug
    path
    name
    name_fr
    title
    title_fr
    pretitle
    pretitle_fr
    subtitle
    subtitle_fr
    published
    edited
    content {
      plain
      text
    }
    content_fr {
      plain
      text
    }
    openGraph {
      title
      description {
        plain
      }
      image {
        url2x
        thumbnails {
          full {
            url
            url2x
          }
        }
      }
    }
    challenge {
      icon { id name component }
      color { id name value }
      
        
      
          id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
      
        
        
              openGraph { 
                id title 
                
                image { 
                  id url url2x 
                  thumbnails { 
                    id bubbleMedium { id url url2x }
                  }
                  
                } 
              }
            
      
      backgroundImage {
        id
        image {
          id
          url
          url2x
        }
      }
    }
    color {
      id
      name
      value
    }
    typeLabel
    intro {
      plain
      text
    }
    intro_fr {
      plain
      text
    }
    outro {
      text
    }
    outro_fr {
      text
    }
    videos {
      id
      name
      url
      thumbnail {
        id
        url
        url2x
      }
    }
    imageAssets {
      id
      name
      image {
        id
        url
        url2x
      }
    }
    organisations {
      id
      name
      slug
      path
      logo {
        id
        url
        url2x
      }
    }
    challenges {
      id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
      icon { id name component }
      color { id name value }
      advertisements {
        id name slug url __typename
        description { id text }
        image {
          image { id url url2x type width height }
          landscapeImage { url url2x width height }
          tabletImage { id url url2x width height }
          portraitImage { id url url2x width height }
        }
      }
    }
    authors {
      id
      name
      slug
      role { id name }
      isMember
      bio { id text html }
      organisation {
        id
        name
      }
      linkedin
      photo {
        id
        url
        url2x
      }
      positions {
        id
        primary
        positions {
          id
          name
          name_fr
        }
        organisation {
          id
          name
        }
      }
    }
    people {
      id
      name
      slug
      path
      organisation {
        id
        name
      }
      linkedin
      photo {
        id
        url
        url2x
      }
      positions {
        id
        primary
        positions {
          id
          name
          name_fr
        }
        organisation {
          id
          name
        }
      }
    }
    embeds {
      citations {
        slug
        url
        name
        authors {
          id
          name
          slug
        }
        authorShowsEtAl
        edition
        publication
        date
        accessDate
        startPage
        volume
        footnoteNumber
        year
      }
      advertisements {
        id name slug url __typename
        description { id text }
        image {
          image { id url url2x type width height }
          landscapeImage { url url2x width height }
          tabletImage { id url url2x width height }
          portraitImage { id url url2x width height }
        }
      }
      pages {
        id
        name
        slug
        path
        openGraph {
          title
          description {
            plain
          }
          image {
            url
            url2x
          }
        }
      }
      people {
        id
        name
        slug
        path
        organisation {
          id
          name
        }
        position
        photo {
          id
          url
          url2x
        }
      }
      imageAssets {
        id
        slug
        image {
          id
          url
          url2x
          width
          height
        }
      }
    }

    banners {
      id
      name
      slug
      title
      description {
        text
      }
      alternateText
      image {
        id
        url
        url2x
        width
        height
      }
    }
  } }
}

`;

